<template>
    <div style="background: white; padding: 20px; margin-top: 10px; margin-left: 30px;">

        <!-- 企业基本信息 -->
        <el-card class="detail-card">
            <div slot="header" class="clearfix">
                <span>企业基本信息</span>
            </div>
            <el-descriptions :column="2" border>

                <el-descriptions-item label="企业名称">{{ reviewData.companyName }}</el-descriptions-item>
                <el-descriptions-item label="">{{ }}</el-descriptions-item>

            </el-descriptions>


            <el-descriptions :column="2" border>
                <el-descriptions-item label="统一社会信用代码">{{ reviewData.socialCreditCode }}</el-descriptions-item>
                <el-descriptions-item label="公司类型">{{ reviewData.companyType }}</el-descriptions-item>

                <el-descriptions-item label="注册资金">{{ reviewData.registeredCapital }}</el-descriptions-item>
                <el-descriptions-item label="注册地址">{{ reviewData.registeredAddress }}</el-descriptions-item>

                <el-descriptions-item label="成立日期">{{ reviewData.setUpTime }}</el-descriptions-item>
                <el-descriptions-item label="经营期限">{{ reviewData.operatingPeriod }}</el-descriptions-item>

                <el-descriptions-item label="企业ID">{{ reviewData.companyId }}</el-descriptions-item>
                <el-descriptions-item label="用户ID">{{ reviewData.userId }}</el-descriptions-item>

            </el-descriptions>


            <el-descriptions :column="2" border>
                <el-descriptions-item label="开户行">{{ reviewData.accountBankName }}</el-descriptions-item>
                <el-descriptions-item label="">{{ }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="对公账户名称">{{ reviewData.accountName }}</el-descriptions-item>
                <el-descriptions-item label="对公账户">{{ reviewData.accountCode }}</el-descriptions-item>
            </el-descriptions>


            <el-descriptions :column="2" border>
                <el-descriptions-item label="联系人姓名">{{ reviewData.contactsName }}</el-descriptions-item>
                <el-descriptions-item label="">{{ }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="联系人电话">{{ reviewData.contactsPhone }}</el-descriptions-item>
                <el-descriptions-item label="联系人邮箱">{{ reviewData.contactsEmail }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="1" border>
                <el-descriptions-item label="经营范围">{{ reviewData.businessNature }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="2" border>
                <el-descriptions-item label="法人代表">{{ reviewData.legalPerson }}</el-descriptions-item>
                <el-descriptions-item label="经办人是否为法人">{{ reviewData.isLegalPerson }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="2" border>
                <el-descriptions-item label="营业执照">
                    <div class="image-container">
                        <img class="idcard-image" :src="reviewData.businessLicense" alt="营业执照"
                            @click="handleClickBusinessLicense" />
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="">{{ }}</el-descriptions-item>

            </el-descriptions>

            <el-descriptions :column="2" border>
                <el-descriptions-item label="法人身份证正面">
                    <div class="image-container">
                        <img class="idcard-image" :src="reviewData.legalPersonIdCardFront" alt="法人身份证正面"
                            @click="handleClickLegalPersonIdCardFront" />
                    </div>
                </el-descriptions-item>

                <el-descriptions-item label="法人身份证背面">
                    <div class="image-container">
                        <img class="idcard-image" :src="reviewData.legalPersonIdCardBack" alt="法人身份证背面"
                            @click="handleClickLegalPersonIdCardBack" />
                    </div>
                </el-descriptions-item>
            </el-descriptions>


            <!-- 经办人身份证信息（当经办人不是法人时显示） -->
            <div v-if="reviewData.isLegalPerson === '否'">
                <el-descriptions :column="2" border>
                    <el-descriptions-item label="经办人身份证正面">
                        <div class="image-container">
                            <img class="idcard-image" :src="reviewData.handlePersonIdCardFront" alt="经办人身份证正面"
                                @click="handleClickHandlePersonIdCardFront" />
                        </div>
                    </el-descriptions-item>

                    <el-descriptions-item label="经办人身份证背面">
                        <div class="image-container">
                            <img class="idcard-image" :src="reviewData.handlePersonIdCardBack" alt="经办人身份证背面"
                                @click="handleClickHandlePersonIdCardBack" />
                        </div>
                    </el-descriptions-item>

                    <el-descriptions-item label="企业身份审核授权书">
                        <el-link type="primary" v-if="reviewData.companyAuthorization"
                            @click="downloadFile(reviewData.companyAuthorization)">{{
                                reviewData.companyAuthorization }}</el-link>
                        <span v-else>无</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div
                :style="{ backgroundColor: reviewData.declarationChecked ? '#f0f9eb' : 'transparent', padding: '10px', borderRadius: '4px' }">
                <el-checkbox :checked="true" :disabled="true" style="margin-right: 10px;"></el-checkbox>
                <span style="color: #000;">
                    我单位财务和经营状况良好，近三年没有发生重大数据安全事故没有因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚，若在数据交易过程中发现我单位近三年内在经营活动中有重大违法记录，我单位将承担因此引起的一切后果，特此声明!
                </span>
            </div>
        </el-card>


        <!--审核标准 -->
        <el-card class=" detail-card">
            <div slot="header" class="clearfix">
                <span class="required-field">审核标准</span>
            </div>
            <div class="review-standard-item">
                <span>经营状态是否正常</span>
                <el-radio-group v-model="auditCriteria1">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div class="review-standard-item">
                <span>是否为失信惩戒对象</span>
                <el-radio-group v-model="auditCriteria2">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div class="review-standard-item">
                <span>是否曾因数据安全而受到行政处罚</span>
                <el-radio-group v-model="auditCriteria3">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div class="review-standard-item">
                <span>是否为重大税收违法案件当事人</span>
                <el-radio-group v-model="auditCriteria4">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div class="review-standard-item">
                <span>是否被列入政府采购严重违法失信行为记录名单</span>
                <el-radio-group v-model="auditCriteria5">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div class="review-standard-item">
                <span>企业是否有行贿犯罪记录</span>
                <el-radio-group v-model="auditCriteria6">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
        </el-card>


        <!-- 审核截图上传/查看 -->
        <el-card class="detail-card">
            <div slot="header" class="clearfix">
                <span class="required-field">查看审核截图</span>
            </div>
            <div style="color: #f56c6c; margin-bottom: 20px; line-height: 1.5;">
                注: 审核人员审核企业是否按企业身份完整填写相关信息并盖章，并且在
                <a href="https://www.creditchina.gov.cn" target="_blank" style="color: #409EFF;">信用中国</a>、
                <a href="http://www.ccgp.gov.cn/" target="_blank" style="color: #409EFF;">中国政府采购网</a>、
                <a href="https://wenshu.court.gov.cn/" target="_blank" style="color: #409EFF;">中国裁判文书网</a>、
                <a href="https://zxgk.court.gov.cn/" target="_blank" style="color: #409EFF;">中国执行信息公开网</a>
                上查询企业相关信息，并将查询的截图留存。
            </div>

            <div class="screenshot-grid">
                <!-- 信用中国查询截图 -->
                <div class="screenshot-item">
                    <div class="screenshot-title">信用中国查询截图</div>
                    <div class="screenshot-viewer" @click="previewImage(reviewData.creditChinaScreenshot)">
                        <div v-if="!reviewData.creditChinaScreenshot" class="no-image-placeholder">
                            <i class="el-icon-picture-outline placeholder-icon"></i>
                            <div class="placeholder-text">暂无截图</div>
                        </div>
                        <img v-else :src="reviewData.creditChinaScreenshot" class="screenshot-image" alt="信用中国查询截图" />
                    </div>
                    <div class="screenshot-actions">
                        <el-button type="text" size="small" @click="previewImage(reviewData.creditChinaScreenshot)"
                            :disabled="!reviewData.creditChinaScreenshot">
                            查看大图
                        </el-button>
                    </div>
                </div>

                <!-- 中国政府采购网查询截图 -->
                <div class="screenshot-item">
                    <div class="screenshot-title">中国政府采购网查询截图</div>
                    <div class="screenshot-viewer" @click="previewImage(reviewData.ccgpScreenshot)">
                        <div v-if="!reviewData.ccgpScreenshot" class="no-image-placeholder">
                            <i class="el-icon-picture-outline placeholder-icon"></i>
                            <div class="placeholder-text">暂无截图</div>
                        </div>
                        <img v-else :src="reviewData.ccgpScreenshot" class="screenshot-image" alt="中国政府采购网查询截图" />
                    </div>
                    <div class="screenshot-actions">
                        <el-button type="text" size="small" @click="previewImage(reviewData.ccgpScreenshot)"
                            :disabled="!reviewData.ccgpScreenshot">
                            查看大图
                        </el-button>
                    </div>
                </div>

                <!-- 中国裁判文书网查询截图 -->
                <div class="screenshot-item">
                    <div class="screenshot-title">中国裁判文书网查询截图</div>
                    <div class="screenshot-viewer" @click="previewImage(reviewData.courtScreenshot)">
                        <div v-if="!reviewData.courtScreenshot" class="no-image-placeholder">
                            <i class="el-icon-picture-outline placeholder-icon"></i>
                            <div class="placeholder-text">暂无截图</div>
                        </div>
                        <img v-else :src="reviewData.courtScreenshot" class="screenshot-image" alt="中国裁判文书网查询截图" />
                    </div>
                    <div class="screenshot-actions">
                        <el-button type="text" size="small" @click="previewImage(reviewData.courtScreenshot)"
                            :disabled="!reviewData.courtScreenshot">
                            查看大图
                        </el-button>
                    </div>
                </div>

                <!-- 中国执行信息公开网 -->
                <div class="screenshot-item">
                    <div class="screenshot-title">中国执行信息公开网</div>
                    <div class="screenshot-viewer" @click="previewImage(reviewData.zhiXingScreenshot)">
                        <div v-if="!reviewData.zhiXingScreenshot" class="no-image-placeholder">
                            <i class="el-icon-picture-outline placeholder-icon"></i>
                            <div class="placeholder-text">暂无截图</div>
                        </div>
                        <img v-else :src="reviewData.zhiXingScreenshot" class="screenshot-image" alt="中国执行信息公开网截图" />
                    </div>
                    <div class="screenshot-actions">
                        <el-button type="text" size="small" @click="previewImage(reviewData.zhiXingScreenshot)"
                            :disabled="!reviewData.zhiXingScreenshot">
                            查看大图
                        </el-button>
                    </div>
                </div>
            </div>
        </el-card>

        <!-- 审核意见 -->
        <el-card class="detail-card">
            <div slot="header" class="clearfix">
                <span class="required-field">审核意见</span>
            </div>
            <el-input v-model="reviewComment" type="textarea" :rows="4" placeholder="请输入审核意见"
                class="review-comment-input">
            </el-input>
        </el-card>

        <!-- 操作按钮 -->
        <div class="action-buttons">
            <el-button type="success" @click="submitReviewPass" :disabled="!canSubmit">
                审核通过
            </el-button>
            <el-button type="danger" @click="submitReviewRejected">
                驳回修改
            </el-button>
        </div>


        <!-- 在模板中，将两个对话框合并为一个 -->
        <el-dialog :visible.sync="dialogVisible" append-to-body custom-class="image-preview-dialog"
            :modal-append-to-body="false" :close-on-click-modal="true" width="80%" top="5vh"
            :before-close="() => { dialogVisible = false }">
            <div slot="title" class="preview-title">
                <span>图片预览</span>
            </div>
            <div class="preview-content">
                <img width="100%" :src="dialogImageUrl" alt="图片预览" @error="handleImageError"
                    style="max-height: 70vh; object-fit: contain; border-radius: 4px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            </div>
        </el-dialog>
    </div>


</template>

<script>
export default {
    name: "CompanyReview",
    data() {
        return {
            reviewData: {
                declarationChecked: true,
                handlePersonIdCardFront: '',
                handlePersonIdCardBack: ''
            },
            reviewComment: "",
            loading: false,
            auditCriteria1: null,
            auditCriteria2: null,
            auditCriteria3: null,
            auditCriteria4: null,
            auditCriteria5: null,
            auditCriteria6: null,
            creditChinaScreenshot: null,
            ccgpScreenshot: null,
            courtScreenshot: null,
            zhiXingScreenshot: null,
            dialogVisible: false,
            dialogImageUrl: '',
            previewVisible: false,
            // previewImageUrl: ''
        };
    },


    computed: {
        canSubmit() {
            return this.auditCriteria1 !== null &&
                this.auditCriteria2 !== null &&
                this.auditCriteria3 !== null &&
                this.auditCriteria4 !== null &&
                this.auditCriteria5 !== null &&
                this.auditCriteria6 !== null;
        }
    },
    created() {
        //console.log('路由参数:', this.$route.query); // 调试日志
        try {
            if (this.$route.query.formData) {
                this.reviewData = JSON.parse(this.$route.query.formData);
                // 确保所有字段都有默认值
                this.reviewData = {
                    id: "",
                    typeName: "",
                    title: "",
                    published: true,
                    content: "",
                    companyId: "",
                    userId: "",
                    companyName: "",
                    socialCreditCode: this.socialCreditCode || "",
                    companyType: "",
                    registeredCapital: "",

                    legalPerson: "",
                    setUpTime: "",
                    //operatingPeriod: "2008-01-01 至 2028-01-01",

                    accountBankName: "",
                    accountName: "",
                    accountCode: "",

                    contactsName: "",
                    contactsPhone: "",
                    contactsEmail: "",

                    registeredAddress: "",
                    businessNature: "",
                    isLegalPerson: "",

                    picture: "",
                    avatar: "",
                    companyLogo: "",

                    creditChinaScreenshot: "",
                    ccgpScreenshot: "",
                    courtScreenshot: "",
                    zhiXingScreenshot: "",

                    legalPersonIdCardFront: "",
                    legalPersonIdCardBack: "",
                    ...this.reviewData
                };
            } else if (this.$route.query.id) {
                this.loadReviewData(this.$route.query.id);
            } else {
                this.initReviewData();
            }
        } catch (error) {
            console.error('解析表单数据失败:', error);
            this.$message.error('加载审核数据失败');
            this.initReviewData();
        }
    },



    created() {
        //console.log("companyId1 ：" + this.$route.query.companyId)

        this.companyId = this.$route.query.companyId;

        this.loadData();
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString();
        },

        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/authorization/download?companyId=' + this.companyId,
                    responseType: 'blob'
                });
                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        previewImage(url) {
            if (url) {
                this.handlePictureCardPreview(url);
            }
        },

        async loadData() {
            try {


                //console.log("companyId" + this.companyId)

                // 获取主体信息
                const companyInfo = await this.getRequest('/web/companyDetail/queryByCompanyId?companyId=' + this.companyId,);

                // 获取资产信息
                if (companyInfo && companyInfo.status === 200) {
                    this.reviewData = {
                        ...companyInfo.data,

                    };
                }
                console.log("response.data:", companyInfo.data);


                this.getBusinessLicense();
                this.getLegalPersonIdCardFront();
                this.getLegalPersonIdCardBack();
                if (this.reviewData.isLegalPerson === '否') {
                    this.gethandlePersonIdCardFront();
                    this.gethandlePersonIdCardBack();
                }
                this.getCreditChinaScreenshot();
                this.getCcgpScreenshot();
                this.getCourtScreenshot();
                this.getZhiXingScreenshot();




            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
            }
        },

        upload_images(options) {
            const { file, onProgress, onSuccess, onError } = options;
            const formData = new FormData();
            formData.append('file', file);

            // 根据上传类型设置不同参数
            let type = '';
            if (options.action === 'creditChinaScreenshot') {
                type = 'creditChinaScreenshot';
            } else if (options.action === 'ccgpScreenshot') {
                type = 'ccgpScreenshot';
            } else if (options.action === 'courtScreenshot') {
                type = 'courtScreenshot';
            } else if (options.action === 'zhiXingScreenshot') {
                type = 'zhiXingScreenshot';
            }
            formData.append('type', type);
            formData.append('userId', this.reviewData.userId);

            this.$axios.post('/web/images/upload', formData, {
                responseType: 'blob'
            }).then(response => {
                const fileUrl = URL.createObjectURL(response.data);
                switch (type) {
                    case 'creditChinaScreenshot':
                        this.reviewData.creditChinaScreenshot = fileUrl;
                        break;
                    case 'ccgpScreenshot':
                        this.reviewData.ccgpScreenshot = fileUrl;
                        break;
                    case 'courtScreenshot':
                        this.reviewData.courtScreenshot = fileUrl;
                        break;
                    case 'zhiXingScreenshot':
                        this.reviewData.zhiXingScreenshot = fileUrl;
                        break;
                }
                this.$message.success('文件上传成功');
            }).catch(error => {
                console.error('获取失败:', error);
                this.$message.error('获取失败');
            });
        },
        // 从接口加载审核数据
        loadReviewData(id) {
            this.loading = true;
            const user = JSON.parse(localStorage.getItem('user'));
            this.$axios.get(`/web/dataAssets/query?userId=${user.id}&dataAssetsId=${dataAssetsId}`)
                .then(response => {
                    this.reviewData = response.data;
                    // 确保所有字段都有默认值
                    this.reviewData = {
                        assetName: '',
                        dataSource: '',
                        dataType: '',
                        industry: '',
                        region: '',
                        dataScaleType: 'structured',
                        tableCount: 0,
                        fieldCount: 0,
                        recordCount: 0,
                        storageSize: 0,
                        fileCount: 0,
                        dataStartTime: '',
                        dataEndTime: '',
                        updateCycle: '',
                        rightsTypes: [],
                        assetsStartTime: '',
                        assetsEndTime: '',
                        usageLimit: '',
                        companyAuthorization: null,
                        verificationFile: null,
                        commitmentFile: null,
                        ...this.reviewData
                    };
                })
                .catch(error => {
                    this.$message.error("获取审核数据失败: " + error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 初始化审核数据
        initReviewData() {
            if (this.$route.query.id) {
                this.loadReviewData(this.$route.query.id);
            } else {
                this.loading = true;
                this.$axios.get("/web/inti")
                    .then(response => {
                        this.reviewData = response.data;
                        // 确保所有字段都有默认值
                        this.reviewData = {
                            assetName: '',
                            dataSource: '',
                            dataType: '',
                            industry: '',
                            region: '',
                            dataScaleType: 'structured',
                            tableCount: 0,
                            fieldCount: 0,
                            recordCount: 0,
                            storageSize: 0,
                            fileCount: 0,
                            dataStartTime: '',
                            dataEndTime: '',
                            updateCycle: '',
                            rightsTypes: [],
                            assetsStartTime: '',
                            assetsEndTime: '',
                            usageLimit: '',
                            companyAuthorization: null,
                            verificationFile: null,
                            commitmentFile: null,
                            ...this.reviewData
                        };
                    })
                    .catch(error => {
                        this.$message.error("获取审核数据失败: " + error.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        getImageUrl(path) {
            if (!path) return '';
            if (path.startsWith('http') || path.startsWith('/')) {
                return path;
            }
            return `/api/file/download?filePath=${encodeURIComponent(path)}`;
        },
        handleClickBusinessLicense() {
            this.handlePictureCardPreview(this.reviewData.businessLicense);
        },
        handleClickLegalPersonIdCardFront() {
            this.handlePictureCardPreview(this.reviewData.legalPersonIdCardFront);
        },
        handleClickLegalPersonIdCardBack() {
            this.handlePictureCardPreview(this.reviewData.legalPersonIdCardBack);
        },
        handleClickHandlePersonIdCardFront() {
            this.handlePictureCardPreview(this.reviewData.handlePersonIdCardFront);
        },
        handleClickHandlePersonIdCardBack() {
            this.handlePictureCardPreview(this.reviewData.handlePersonIdCardBack);
        },
        // 统一预览方法
        handlePictureCardPreview(url) {
            if (!url) {
                this.$message.warning('图片加载中，请稍后再试');
                return;
            }

            this.dialogVisible = false;
            this.$nextTick(() => {
                const fullUrl = url.startsWith('blob:') ? url :
                    (url.startsWith('http') ? url : `/api${url}`);

                this.dialogImageUrl = fullUrl;
                this.dialogVisible = true;

                this.$nextTick(() => {
                    const dialog = document.querySelector('.el-dialog__wrapper');
                    if (dialog) {
                        dialog.style.display = 'flex';
                        dialog.style.alignItems = 'center';
                        dialog.style.justifyContent = 'center';
                    }
                });
            });
        },
        // 提交审核结果
        submitReviewRejected(action) {
            if (!this.reviewComment) {
                this.$message.warning("驳回请填写审核意见");
                return;
            }
            this.loading = true;
            this.$axios.get(`/web/companyInfo/approve/rejected?id=${this.reviewData.id}&companyId=${this.reviewData.companyId}&reviewComment=${this.reviewComment}`)
                .then(() => {
                    this.$message.success(`审核驳回成功`);
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$message.error(`审核提交失败: ${error.message}`);
                })
                .finally(() => {
                    this.loading = false;
                });
        },


        submitReviewPass(action) {
            // 审核通过可以不填写审核意见
            // if (!this.reviewComment) {
            //   this.$message.warning("请填写审批意见！");
            //   return;
            // }

            // 检查审核标准项
            const unqualifiedItems = [];
            if (this.auditCriteria1 === false) unqualifiedItems.push("经营状态不正常");
            if (this.auditCriteria2 === true) unqualifiedItems.push("是失信惩戒对象");
            if (this.auditCriteria3 === true) unqualifiedItems.push("曾因数据安全而受到行政处罚");
            if (this.auditCriteria4 === true) unqualifiedItems.push("是重大税收违法案件当事人");
            if (this.auditCriteria5 === true) unqualifiedItems.push("被列入政府采购严重违法失信行为记录名单");
            if (this.auditCriteria6 === true) unqualifiedItems.push("企业存在行贿犯罪记录");



            if (unqualifiedItems.length > 0) {
                this.$confirm(`${unqualifiedItems.join("，")}，是否继续提交？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.doSubmitReviewPass();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消提交'
                    });
                });
            } else {
                this.doSubmitReviewPass();
            }
        },

        doSubmitReviewPass() {
            if (!this.reviewData.creditChinaScreenshot) {
                this.$message.warning("请上传信用中国查询截图！");
                return;
            }

            if (!this.reviewData.ccgpScreenshot) {
                this.$message.warning("请上传中国政府采购网查询截图！");
                return;
            }

            if (!this.reviewData.courtScreenshot) {
                this.$message.warning("请上传中国裁判文书网查询截图！");
                return;
            }
            if (!this.reviewData.zhiXingScreenshot) {
                this.$message.warning("请上传中国执行信息公开网查询截图！");
                return;
            }

            this.loading = true;
            this.$axios.get(`/web/companyInfo/approve/pass?id=${this.reviewData.id}&companyId=${this.reviewData.companyId}&reviewComment=${this.reviewComment}`)
                .then(() => {
                    this.$message.success(`审核通过成功`);
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$message.error(`审核提交失败: ${error.message}`);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getBusinessLicense() {
            this.axios.get(`/web/images/get?type=businessLicense&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data.size > 0) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.businessLicense = imageUrl;
                    //console.log('营业执照URL:', imageUrl);
                } else {
                    console.warn('营业执照图片为空');
                    this.reviewData.businessLicense = '';
                }
            }).catch(error => {
                console.error('获取营业执照失败:', error);
                this.reviewData.businessLicense = '';
            });
        },



        getLegalPersonIdCardFront() {
            this.axios.get(`/web/images/get?type=legalPersonIdCardFront&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data.size > 0) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.legalPersonIdCardFront = imageUrl;
                    //console.log('法人身份证正面URL:', imageUrl);
                } else {
                    console.warn('法人身份证正面图片为空');
                    this.reviewData.legalPersonIdCardFront = '';
                }
            }).catch(error => {
                console.error('获取法人身份证正面失败:', error);
                this.reviewData.legalPersonIdCardFront = '';
            });
        },

        getLegalPersonIdCardBack() {
            this.axios.get(`/web/images/get?type=legalPersonIdCardBack&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data.size > 0) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.legalPersonIdCardBack = imageUrl;
                    //console.log('法人身份证反面URL:', imageUrl);
                } else {
                    console.warn('法人身份证反面图片为空');
                    this.reviewData.legalPersonIdCardBack = '';
                }
            }).catch(error => {
                console.error('获取法人身份证反面失败:', error);
                this.reviewData.legalPersonIdCardBack = '';
            });
        },

        gethandlePersonIdCardFront() {
            this.axios.get(`/web/images/get?type=handlePersonIdCardFront&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data.size > 0) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.handlePersonIdCardFront = imageUrl;
                    //console.log('经办人身份证正面URL:', imageUrl);
                } else {
                    console.warn('经办人身份证正面图片为空');
                    this.reviewData.handlePersonIdCardFront = '';
                }
            }).catch(error => {
                console.error('获取经办人身份证正面失败:', error);
                this.reviewData.handlePersonIdCardFront = '';
            });
        },

        gethandlePersonIdCardBack() {
            this.axios.get(`/web/images/get?type=handlePersonIdCardBack&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data.size > 0) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.handlePersonIdCardBack = imageUrl;
                    //console.log('经办人身份证反面URL:', imageUrl);
                } else {
                    console.warn('经办人身份证反面图片为空');
                    this.reviewData.handlePersonIdCardBack = '';
                }
            }).catch(error => {
                console.error('获取经办人身份证反面失败:', error);
                this.reviewData.handlePersonIdCardBack = '';
            });
        },







        getCreditChinaScreenshot() {
            this.axios.get(`/web/images/get?type=creditChinaScreenshot&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.creditChinaScreenshot = imageUrl;
                }

            }).catch(error => {

            });
        },
        getCcgpScreenshot() {
            this.axios.get(`/web/images/get?type=ccgpScreenshot&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.ccgpScreenshot = imageUrl;
                }

            }).catch(error => {

            });
        },
        getCourtScreenshot() {
            this.axios.get(`/web/images/get?type=courtScreenshot&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.courtScreenshot = imageUrl;
                }


            }).catch(error => {

            });
        },
        getZhiXingScreenshot() {
            this.axios.get(`/web/images/get?type=zhiXingScreenshot&userId=${this.reviewData.userId}`, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const imageUrl = URL.createObjectURL(response.data);
                    this.reviewData.zhiXingScreenshot = imageUrl;
                }


            }).catch(error => {

            });
        },
        handleImageError(e) {
            console.error('图片加载失败:', e);
            const img = e.target;
            img.style.display = 'none';

            // 检查是否已经添加过错误提示
            if (!img.parentNode.querySelector('.image-error-message')) {
                const errorDiv = document.createElement('div');
                errorDiv.className = 'image-error-message';
                errorDiv.textContent = '图片加载失败';
                errorDiv.style.color = '#f56c6c';
                errorDiv.style.textAlign = 'center';
                errorDiv.style.padding = '20px';

                img.parentNode.appendChild(errorDiv);
            }
        }



    }
};


</script>

<style scoped>
.el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog {
    max-width: 80%;
    max-height: 80%;
}

.el-dialog__body img {
    width: 100%;
    height: auto;
    max-height: 70vh;
    object-fit: contain;
}

.review-container {
    padding: 20px;
    background-color: #f5f7fa;
}

.detail-card {
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.detail-card>>>.el-card__header {
    background-color: #e2e4e7;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    border-radius: 8px 8px 0 0;
}

.company-logo {
    width: 100px;
    height: 100px;
    object-fit: contain;
}

.id-card {
    width: 200px;
    height: 120px;
    object-fit: contain;
    border: 1px solid #ebeef5;
    background-color: #f5f5f5;
    margin: 5px;
}

.image-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
    min-height: 130px;
    justify-content: flex-start;
}

.review-standard-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #ebeef5;
}

.review-standard-item:last-child {
    border-bottom: none;
}

.review-comment-input {
    width: 100%;
}

.action-buttons {
    margin-top: 20px;
    text-align: center;
}

.required-field::before {
    margin-right: 4px;
}

.detail-card-1>>>.el-descriptions-item__label {
    font-size: var(--label-font-size, 50px);
    color: var(--label-color, #bb3e3e);
    background-color: var(--label-color, #fcfcfc);
    width: var(--label-width, 100px);

}

.detail-card>>>.el-descriptions-item__label {
    font-size: var(--label-font-size, 18px);
    color: var(--label-color, #000000);
    background-color: var(--label-color, #fcfcfc);
    width: var(--label-width, 100px);

}

.detail-card>>>.el-descriptions-item__content {
    font-size: var(--content-font-size, 16px);
    color: var(--content-color, #6b6b6b);
    background-color: var(--content-color, #ffffff);
    width: var(--content-width, 300px);
}

.idcard-image {
    width: 210px;
    height: 133px;
    border: 1px solid #eee;
    border-radius: 4px;
    object-fit: cover;
    transition: transform 0.3s ease;
    cursor: pointer;
}

.idcard-image:hover {
    transform: scale(1.03);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.image-preview-dialog {
    z-index: 9999 !important;
}

.image-preview-dialog .el-dialog {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    margin-top: 0 !important;
}

.image-preview-dialog .el-dialog__body {
    flex: 1;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.image-preview-dialog .el-dialog__header {
    padding: 20px;
}

.image-preview-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
}

/* 截图网格布局 */
.screenshot-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
    margin-top: 20px;
}

/* 截图项样式 */
.screenshot-item {
    display: flex;
    flex-direction: column;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;
    border: 1px solid #e8e8e8;
}

.screenshot-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #409EFF;
}

/* 截图标题 */
.screenshot-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
    text-align: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;
}

/* 截图查看器 */
.screenshot-viewer {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e0e0e0;
}

/* 截图图片 */
.screenshot-image {
    width: 100%;
    height: 100%;
    max-height: 180px;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.screenshot-image:hover {
    transform: scale(1.02);
}

/* 无图片占位符 */
.no-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 180px;
    color: #999;
    background: #fafafa;
}

.placeholder-icon {
    font-size: 36px;
    margin-bottom: 8px;
    color: #c0c4cc;
}

.placeholder-text {
    font-size: 14px;
    color: #909399;
}

/* 截图操作按钮 */
.screenshot-actions {
    margin-top: 12px;
    text-align: center;
    padding-top: 8px;
    border-top: 1px solid #e8e8e8;
}

.screenshot-actions .el-button {
    color: #409EFF;
}

.screenshot-actions .el-button:disabled {
    color: #c0c4cc;
    cursor: not-allowed;
}

/* 预览对话框样式 */
.screenshot-preview-dialog .el-dialog {
    max-width: 90%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
}

.preview-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 10px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.close-btn {
    padding: 0;
    font-size: 18px;
}

.preview-content {
    flex: 1;
    padding: 0 20px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
}

.preview-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .screenshot-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .screenshot-grid {
        grid-template-columns: 1fr;
    }

    .screenshot-item {
        padding: 12px;
    }

    .screenshot-viewer {
        min-height: 160px;
    }

    .no-image-placeholder {
        height: 160px;
    }
}

/* 链接样式优化 */
a {
    text-decoration: none;
    transition: color 0.3s ease;
}

a:hover {
    text-decoration: underline;
    color: #66b1ff;
}
</style>
